<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="home-center">
              <div class="search">
                <div class="search-info">
                  <div class="hotellist-region el-input el-input--large el-input--suffix">
                    <el-input placeholder="Email" v-model="email"></el-input>
                  </div>
                  <div class="search-status el-input el-input--large el-input--suffix">
                    <el-select style="width:300px;" v-model="orderStatus" filterable>
                      <el-option v-for="(item, id) in statusList" :key="id" :label="item" :value="id" class="option-item">{{item}}</el-option>
                    </el-select>
                  </div>
                  <div class="search-status el-input el-input--large el-input--suffix">
                    <el-select style="width:300px;" v-model="permissions" filterable>
                      <el-option key="all" value="all" class="option-item">all</el-option>
                      <el-option v-for="(item, id) in accessLevel" :key="id" :label="item" :value="id" class="option-item">{{item}}</el-option>
                    </el-select>
                  </div>
                  <el-button class="input_button booknow_button" style="float: left;" id="inputButtonPc" @click="searchList">{{$t('search')}}</el-button>
                  <el-button v-if="allPermissions.account === 0" class="input_button display_button" style="float: right;" id="inputButtonPc">Create</el-button>
                  <el-button v-else class="input_button white_button" style="float: right;" id="inputButtonPc" @click="createAccount">Create</el-button>
                </div>
              </div>
              <div class="account-list" :style="heightCss">
                <el-skeleton animated :loading="listShow">
                  <template slot="template">
                    <div class="accountlist">
                      <div style="width: 20%;"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div style="width: 17%;"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div style="width: 15%;"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div style="width: 33%;"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div style="width: 5%;"><el-skeleton-item variant="text" class="template-text" /></div>
                      <div style="width: 10%;"></div>
                    </div>
                  </template>
                  <template>
                    <el-card class="accountlist" :body-style="{ padding: '0px' }">
                      <div class="accountlist" style="width: 100%;padding: 0;">
                        <div style="width: 20%;">Email</div>
                        <div style="width: 17%;">Name</div>
                        <div style="width: 15%;">Type</div>
                        <div style="width: 33%;">Access level</div>
                        <div style="width: 5%;">Status</div>
                        <div style="width: 10%;"></div>
                      </div>
                    </el-card>
                  </template>
                </el-skeleton>
                <el-skeleton :count="10" animated :loading="listShow">
                  <template slot="template">
                    <div class="hotel-info">
                      <div style="width: 20%;"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div style="width: 17%;"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div style="width: 15%;"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div style="width: 33%;"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div style="width: 5%;"><el-skeleton-item variant="text" class="template-info-text" /></div>
                      <div style="width: 10%;"><el-skeleton-item variant="text" style="font-size: 13px; width: 100px; height: 30px;margin: 10px 0; float: right;" class="template-info-text" /></div>
                    </div>
                  </template>
                  <template>
                    <div class="hotel-info" v-for="item in listInfo" :key="item.id" v- v-show="!emptyShow">
                      <div style="width: 20%;">{{item.email}}</div>
                      <div style="width: 17%;">{{item.first_name}} {{item.last_name}}</div>
                      <div style="width: 15%;">{{item.permissionsStr}}</div>
                      <div style="width: 33%;">{{item.accessLevelStr}}</div>
                      <div style="width: 5%;">
                        <el-switch @change="openChangeStatus($event, item)" :value="item.state" active-value="1" inactive-value="2" active-color="rgba(83, 102, 163, 1)" inactive-color="rgba(140, 140, 140, 1)" style="margin: 15px 0px;"></el-switch>
                      </div>
                      <div style="width: 10%;">
                        <button v-if="allPermissions.account === 0" style=" margin: 10px 0; width: 100px; height: 30px; float: right;" type="button" class="display_button">Edit</button>
                        <button v-else style=" margin: 10px 0; width: 100px; height: 30px; float: right;" type="button" class="white_button" @click="editAccount(item)">Edit</button>
                      </div>
                    </div>
                    <div style="height: 140px;" v-show="!emptyShow"></div>
                    <div class="hotel-info" style="width: 100%; text-align: center; border: none;" v-show="emptyShow">
                      <img src="/static/img/account/empty.png" style="width: 160px; height: 160px; margin-top: 80px;opacity: 0.25;">
                      <div class="empty-txt">You have no account~</div>
                    </div>
                  </template>
                </el-skeleton>
                <div class="account-data-page" v-show="!listShow && !emptyShow">
                  <el-pagination background :page-size="pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="7" layout="prev, pager, next" :total="listTotal" :current-page="currentPage" > </el-pagination>
                </div>
                <!-- 弹出框组件 -->
                <!-- 修改状态 弹框 -->
                <el-dialog class="open-dia update-status" title="" :show-close="showStatusClo" :visible.sync="openStatusCom" :width="diaWidth">
                  <div slot="title" style="font-size: 20px; font-weight: 650;color:rgba(83, 102, 163, 1);">Action</div>
                  <div class="dia-content">
                    <div style="overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                      Are you sure you want to proceed with this action? This will result in disabling login access to the account {{itemInfo.email}}.
                    </div>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button class="white_button" style="width: auto; margin-right: 20px;" @click="openStatusCom = false">Cancel</el-button>
                    <el-button class="booknow_button" style="width: auto;" type="primary" @click="changeStatus(toStatus, itemInfo)">Confirm</el-button>
                  </div>
                </el-dialog>
                <el-dialog class="open-dia" title="" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :show-close="showClo" :visible.sync="dialogVisible" :width="diaWidth">
                  <div slot="title" style="font-size: 20px; font-weight: 650;color:#333333;">Create Account</div>
                  <div class="dia-content">
                    <el-form ref="myForm" :model="formData" label-width="110px">
                      <el-form-item label="Email:" :class="emailClass">
                        <span v-if="formData.id !== undefined && formData.email.length > 0" v-html="formData.email"></span>
                        <el-input v-else v-model="formData.email" placeholder="Email" ref="email"></el-input>
                      </el-form-item>
                      <el-form-item label="First name:" :class="firstNameClass">
                        <el-input v-model="formData.first_name" placeholder="First name" ref="first_name"></el-input>
                      </el-form-item>
                      <el-form-item label="Last name:" :class="lastNameClass">
                        <el-input v-model="formData.last_name" placeholder="Last name" ref="last_name"></el-input>
                      </el-form-item>
                      <el-form-item label="Access level:" :class="permissionsClass">
                        <el-select v-model="formData.permissions" placeholder="Please select" ref="permissions">
                          <el-option v-for="(item, id) in accessLevel" :key="id" :label="item" :value="id" class="option-item">{{item}}</el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button class="white_button" style="width: auto; margin-right: 20px;" @click="dialogVisible = false">Cancel</el-button>
                    <el-button class="booknow_button" style="width: auto;" type="primary" @click="doCreateAccount">Confirm</el-button>
                  </div>
                </el-dialog>
              </div>
            </div>
          </el-main>
        </slot>
      </div>
    </div>
    <publicFooter></publicFooter>
  </el-container>
</template>

<script scoped>
import { accountList, changeStatus } from '@/request/account.js'
import publicFooter from '@/components/public/publicFooter'
import publicSearch from '@/components/public/publicSearch'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
export default {
  name: 'myAccount',
  components: {
    publicFooter,
    publicHeader,
    publicSearch,
    publicMenu
  },
  props: [],
  data () {
    return {
      dialogVisible: false,
      showClo: true,
      showStatusClo: false,
      openStatusCom: false,
      timeout: null,
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      someArray: [],
      star: '',
      end: '',
      source: this.common.sourceSet(),
      diaWidth: '600px',
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      personWidth: (document.body.clientWidth - 74) * 0.2182 - 10,
      mainMinHeight: document.documentElement.clientHeight - 245,
      heightCss: {'min-height': '500px'},
      radioColor: ' rgba(241, 81, 27, 1)',
      email: '',
      orderStatus: 'all',
      statusList: {'all': 'All status', '1': 'Active', '2': 'Inactive'},
      permissions: 'all',
      formData: {'email': '', 'first_name': '', 'last_name': '', 'permissions': ''},
      accessLevel: {'1': 'Administrator'},
      listInfo: {},
      permissionsList: {},
      currentPage: 1, // 当前默认显示第几页
      listTotal: 0, // 分页总条数
      pageSize: 20, // 每页显示多少条数据，记住这里一定要是10的倍数，不然无效
      listShow: true,
      emptyShow: false,
      status: {},
      emailClass: '',
      firstNameClass: '',
      lastNameClass: '',
      permissionsClass: '',
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      toStatus: '',
      itemInfo: {}
    }
  },
  created: function () {
    localStorage.removeItem('LoginWebsiteAddress')
  },
  mounted: function () {
    this.heightCss = {'min-height': this.mainMinHeight + 'px'}
    // 存储来源
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // 下拉框关闭
    this.getList(this.currentPage)
  },
  methods: {
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    // 分页 size-change  pageSize 改变时会触发 每页条数
    handleSizeChange (val) {
      this.pageSize = val
    },
    // current-change  currentPage 改变时会触发  当前页
    async handleCurrentChange (val) {
      this.currentPage = val
      this.getList(val)
    },
    searchList () {
      this.getList(1)
    },
    getList (page) {
      this.listShow = true
      this.common.stopScroll()
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      this.listInfo = []
      var dataJson = {
        'email': this.email,
        'status': this.orderStatus,
        'permissions': this.permissions,
        'page': page,
        'time': time,
        'language': this.language,
        'source': this.source,
        'token': token,
        'operation': 'accountList'
      }
      var data = this.common.encryptionData(dataJson, this)
      accountList(data).then(res => {
        if (res.data.accountTypeLs !== undefined) {
          this.permissionsList = res.data.accountTypeLs
        }
        if (res.data.accessLevelLs !== undefined) {
          this.accessLevel = res.data.accessLevelLs
        }
        if (res.flag === '200') {
          this.listInfo = res.data.list
          this.listTotal = parseInt(res.data.totalNum)
          this.permissionsList = res.data.accountTypeLs
          this.accessLevel = res.data.accessLevelLs
          localStorage.setItem('total', this.listTotal)
          this.currentPage = parseInt(res.data.currentPage)
          this.pageSize = parseInt(res.data.pageSize)
          this.listShow = false
          this.emptyShow = false
        } else if (res.flag === '110') {
          // 无权限
          this.$router.push({path: '/portal/booking/hotelsearch/HotelList', query: {'source': this.source}})
        } else {
          this.listShow = false
          this.emptyShow = true
        }
      })
      this.common.canScroll()
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    openChangeStatus (newVal, item) {
      if (newVal === 2 || newVal === '2') {
        this.openStatusCom = true
        this.toStatus = newVal
        this.itemInfo = item
        return false
      } else {
        this.changeStatus(newVal, item)
      }
    },
    changeStatus (newVal, row) {
      this.openStatusCom = false
      this.toStatus = newVal
      this.itemInfo = row
      let id = row.id
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {
        'userid': id,
        'state': newVal,
        'time': time,
        'source': this.source,
        'token': token,
        'operation': 'changeStatus'
      }
      var data = this.common.encryptionData(dataJson, this)
      changeStatus(data).then(res => {
        if (res.msg === 'success') {
          row.state = newVal
        } else if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else {
          this.$message({type: 'error', message: res.msg})
          if (res.flag === '110') {
            let locationHref = window.document.location.href
            sessionStorage.setItem('LoginWebsiteAddress', locationHref)
            this.$router.push({name: 'login'})
          }
        }
      })
    },
    createAccount () {
      this.formData = {'email': '', 'first_name': '', 'last_name': '', 'permissions': ''}
      this.dialogVisible = true
    },
    doCreateAccount () {
      let locationHref = window.document.location.href
      var emailpattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.formData.email.length === 0 || !emailpattern.test(this.formData.email)) {
        this.emailClass = 'email-info'
        return false
      } else {
        this.emailClass = ''
      }
      if (this.formData.first_name.length === 0) {
        this.firstNameClass = 'firstname-info'
        return false
      } else {
        this.firstNameClass = ''
      }
      if (this.formData.last_name.length === 0) {
        this.lastNameClass = 'lastname-info'
        return false
      } else {
        this.lastNameClass = ''
      }
      if (this.formData.permissions.length === 0) {
        this.permissionsClass = 'permissions-info'
        return false
      } else {
        this.permissionsClass = ''
      }
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login'})
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {
        'userid': this.formData.id !== undefined ? this.formData.id : '',
        'email': this.formData.email,
        'first_name': this.formData.first_name,
        'last_name': this.formData.last_name,
        'permissions': this.formData.permissions,
        'time': time,
        'source': this.source,
        'token': token,
        'operation': 'save'
      }
      var data = this.common.encryptionData(dataJson, this)
      changeStatus(data).then(res => {
        if (res.flag === '200') {
          this.$message({type: 'success', message: res.msg})
          this.dialogVisible = false
          this.getList(1)
        } else {
          this.$message({type: 'error', message: res.msg})
          if (res.flag === '110') {
            let locationHref = window.document.location.href
            sessionStorage.setItem('LoginWebsiteAddress', locationHref)
            this.$router.push({name: 'login'})
          }
        }
      })
    },
    editAccount (row) {
      this.formData = row
      this.dialogVisible = true
    }
  }
}
</script>
<style type="text/css" scoped>
  body > .el-container {margin-bottom: 40px;}
  .el-container{display:block;}
  .home-center{height: auto;}
  /* 搜索 */
  .search{ height:100px; background: #FFF; border-radius: 5px;}
  .search-info{ height: 48px; padding: 26px 1%;}
  /* orderno */
  .hotellist-region{width:40%;float: left;margin-right:0.6%;}
  .hotellist-region input, .search-status input{background-color:rgba(255,255,255,1);background-image:url(/static/img/account/icon_u25.png);background-repeat:no-repeat;background-size: 20px;background-position: 12px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus, .search-status /deep/ .el-input__inner:focus,.search-status input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-region /deep/ .el-input__inner{padding: 0 53px;height: 48px; background-image: url(/static/img/account/icon_u25.png);background-repeat: no-repeat;background-size: 23px;background-position: 15px center;}
  .hotellist-region /deep/ .el-popover--plain{width:100%;padding:0px;color: #FF6B6D;top: -33px;font-size:12px;height: 28px;line-height: 28px;z-index: 2001;text-align:center;}

  /* 订单状态 */
  .search-status{width:18.8%;float: left;margin-right:0.6%;}
  .search-status .el-select{width: 100% !important;}
  .search-status /deep/ .el-input__inner{height: 48px;}
  /* 按钮 */
  .input_button,.input_button:hover,.input_button:focus{ height: 48px !important; width: 10% !important;}
  .el-button+.el-button { margin: unset !important;}
  /* 列表 */
  .account-list{min-height:200px; margin-top: 15px; background: #FFF; border-radius: 5px; padding:15px; position: relative;}
  .accountlist{width: 98%; background-color: rgba(242, 242, 242, 1);height: 40px;border: none; font-weight: 650; font-size: 14px; color: #333333; line-height: 40px; padding: 0 1%;border-radius: 5px;}
  .accountlist div, .hotel-info div{display:inline-block; float: left;}
  .hotel-info{width: 98%; min-height:50px;height: auto; line-height: 50px; border: none; color: #333333;border-bottom: 1px solid #d2cfcf; clear: both; font-size: 14px; padding: 0 1%;}

  /* 分页 */
  .account-data-page{width:100%;height:100px;text-align:right;margin-top: 40px; position: absolute;bottom: -30px;right: 1%;}
  .account-data-page .el-pagination.is-background .el-pager li,.account-data-page .el-pagination.is-background .btn-prev,.account-data-page .el-pagination.is-background .btn-next,  .account-data-page-list .el-pagination.is-background .el-pager li,.account-data-page-list .el-pagination.is-background .btn-prev,.account-data-page-list .el-pagination.is-background .btn-next{background:white; color: #333333;}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active, /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:rgba(83, 102, 163, 1); color:#FFF;}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{color:white;background-color: rgba(83, 102, 163, 0.6);}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active:hover{color: white;background-color: rgba(83, 102, 163, 1);}
  .el-pagination{padding: 0;}
  /* 弹框 */
  .update-status /deep/ .dia-content {padding: 20px 4%;border-bottom: 1px solid rgba(83, 102, 163, 1); margin: 0;}
  /* 骨架屏 */
  .template-text{width: 80%;margin: 13.5px 0;}
  .template-info-text{width: 80%;margin: 19px 0;}
  .account-list /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover, .hotel-info  /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{box-shadow: none;}

  /* 创建 */
  .dia-content{ margin-top: 20px;border-bottom: 1px solid rgba(83, 102, 163, 1);}
  .dia-content /deep/ .el-input__inner{ width: 450px; border: 1px solid rgba(83, 102, 163, 1);}
  .email-info /deep/ .el-input__inner, .firstname-info /deep/ .el-input__inner, .lastname-info /deep/ .el-input__inner, .permissions-info /deep/ .el-input__inner, .password-info /deep/ .el-input__inner{ width: 450px; border: 1px solid rgba(225, 45, 45, 1);}
  .open-dia /deep/ .el-button+.el-button{margin-left:0px;}
  .open-dia /deep/ .el-button:hover{color:#FFF;background: rgba(41, 111, 247, 1);border: 1px solid rgba(41, 111, 247, 1);}
  .otherreason-msg{border:1px solid red;}
  .open-dia /deep/ .el-dialog__body{padding:0px;color:#333333;}
  .open-dia /deep/ .el-dialog__header{padding: 20px 20px;height: 20px; font-size: 22px; font-weight: 650; line-height: 20px; border-bottom: 1px solid rgba(83, 102, 163, 1);}
  /deep/ .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner,.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner, /deep/ .el-input.is-active .el-input__inner, /deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1) !important;box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
  /deep/ .el-dialog__footer{padding: 20px;}
  /deep/ .el-dialog__headerbtn .el-dialog__close{color: rgba(83, 102, 163, 1);font-weight: 650;}
  .codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
  /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color: rgba(83, 102, 163, 1);}
  /deep/ .el-select-dropdown__item.selected{color: rgba(83, 102, 163, 1) !important;}
</style>



// WEBPACK FOOTER //
// src/components/account/myAccount.vue